<template>
  <div class="person">
    <FormItem :prop="formKey + '.passNo'" label="通行证/护照号码">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'passNo')">{{ formData.passNo }}</span>
      <Input v-else type="text" v-model="formData.passNo" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.passNo" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowpassNo" @click="openEye(formData, 'passNo')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.email'" label="电子邮箱">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'email')">{{ formData.email }}</span>
      <Input v-else type="text" v-model="formData.email" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.email" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowemail" @click="openEye(formData, 'email')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.nationality'" label="国家或地区">
      <lzDicTxt v-if="disabled" :dicCode="formData.nationality" dicType="NATIONAL"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.nationality" dicType="NATIONAL" :transfer="true" clearable> </lzDicSelect>
    </FormItem>

    <FormItem :prop="formKey + '.maritalStatus'" label="婚姻状况">
      <lzDicTxt v-if="disabled" :dicCode="formData.maritalStatus" dicType="MARITAL"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.maritalStatus" dicType="MARITAL" :transfer="true" clearable> </lzDicSelect>
    </FormItem>

    <FormItem :prop="formKey + '.smokingStatus'" label="吸烟状况">
      <span v-if="disabled">{{ formData.smokingStatus | filterSmokingStatus }}</span>
      <Select v-else v-model="formData.smokingStatus" filterable transfer clearable>
        <Option v-for="(txt, value) in $dic.smoking" :value="value" :key="value">{{ txt }}</Option>
      </Select>
    </FormItem>

    <FormItem :prop="formKey + '.educationalStatus'" label="教育程度">
      <lzDicTxt v-if="disabled" :dicCode="formData.educationalStatus" dicType="EDUCATION"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.educationalStatus" dicType="EDUCATION" :transfer="true" clearable> </lzDicSelect>
    </FormItem>

    <FormItem :prop="formKey + '.address'" label="实际住址">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'address')">{{ formData.address }}</span>
      <Input v-else type="text" v-model="formData.address" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.address" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowaddress" @click="openEye(formData, 'address')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.postcode'" label="邮政编码">
      <span v-if="disabled">{{ formData.postcode }}</span>
      <Input v-else type="text" v-model="formData.postcode" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.mailingAddress'" label="通讯住址">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'mailingAddress')">{{ formData.mailingAddress }}</span>
      <Input v-else type="text" v-model="formData.mailingAddress" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.mailingAddress" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowmailingAddress" @click="openEye(formData, 'mailingAddress')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.mailingPostcode'" label="邮政编码">
      <span v-if="disabled">{{ formData.mailingPostcode }}</span>
      <Input v-else type="text" v-model="formData.mailingPostcode" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.professionType'" label="行业种类">
      <lzDicTxt v-if="disabled" :dicCode="formData.professionType" dicType="PROFESSION_TYPE"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.professionType" dicType="PROFESSION_TYPE" :transfer="true" clearable> </lzDicSelect>
    </FormItem>

    <FormItem :prop="formKey + '.monthIncome'" label="月收入(HKD)">
      <span v-if="disabled">{{ formData.monthIncome }}</span>
      <Input v-else type="text" v-model="formData.monthIncome" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.monthDisburse'" label="月支出(HKD)">
      <span v-if="disabled">{{ formData.monthDisburse }}</span>
      <Input v-else type="text" v-model="formData.monthDisburse" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.position'" label="职位">
      <lzDicTxt v-if="disabled" :dicCode="formData.position" dicType="POSITION_TYPE"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.position" dicType="POSITION_TYPE" :transfer="true" clearable> </lzDicSelect>
    </FormItem>

    <FormItem :prop="formKey + '.height'" label="身高(CM)">
      <span v-if="disabled">{{ formData.height }}</span>
      <Input v-else type="text" v-model="formData.height" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.weight'" label="体重(KG)">
      <span v-if="disabled">{{ formData.weight }}</span>
      <Input v-else type="text" v-model="formData.weight" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.companyName'" label="公司/学校名称">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'companyName')">{{ formData.companyName }}</span>
      <Input v-else type="text" v-model="formData.companyName" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.companyName" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowcompanyName" @click="openEye(formData, 'companyName')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.companyAddr'" label="公司/学校地址">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'companyAddr')">{{ formData.companyAddr }}</span>
      <Input v-else type="text" v-model="formData.companyAddr" placeholder="请输入" />
      <a v-if="$parent.$parent && $parent.$parent.disabled && formData.companyAddr" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowcompanyAddr" @click="openEye(formData, 'companyAddr')"></i>
      </a>
    </FormItem>

    <FormItem :prop="formKey + '.companyPostcode'" label="邮政编码">
      <span v-if="disabled">{{ formData.companyPostcode }}</span>
      <Input v-else type="text" v-model="formData.companyPostcode" placeholder="请输入" />
    </FormItem>

    <FormItem :prop="formKey + '.supportNum'" label="供养人数">
      <span v-if="disabled">{{ formData.supportNum }}</span>
      <Input v-else type="text" v-model="formData.supportNum" placeholder="请输入" />
    </FormItem>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import validUserName from '@/components/commons/validUserName';
export default {
  components: { lzDicSelect, validUserName, lzDicTxt },
  mixins: [common],
  props: ['companyList', 'productList', 'formData', 'formKey', 'disabled'],
  data() {
    return {
      title: '',
      yesOrNo: JSON.parse(localStorage.dic)['YES_NO'] // 是否
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() { },
  methods: {
    // 解密
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      let operationType = {
        'email': 4,
        'passNo': 8,
        'address': 7,
        'mailingAddress': 5,
        'companyName': 9,
        'companyAddr': 10
      };
      let customerType = {
        'holder': 1,
        'insurce': 2
      };
      console.log(this.formKey);
      if (!row['eyeShow' + code]) {
        this.descrypt(
          {
            query: row.id,
            operationFunction: 3,
            operationType: operationType[code],
            customerType: customerType[this.formKey]
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
